import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";

const AUTH_CONNECTION_KEY = "legup_auth_connection";

const ALLOWED_CONNECTIONS = new Set([
  "LEGUP-Homebuyers",
  "LEGUP-Lenders",
  "LEGUP-OSS",
  "Username-Password-Authentication",
]);

export default function LoginRecoveryPage() {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

  const redirectStarted = React.useRef(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (isLoading || isAuthenticated || redirectStarted.current) {
      return;
    }

    const restartLogin = async () => {
      redirectStarted.current = true;
      setError("");

      const storedConnection =
        window.sessionStorage.getItem(AUTH_CONNECTION_KEY);

      const connection =
        storedConnection && ALLOWED_CONNECTIONS.has(storedConnection)
          ? storedConnection
          : null;

      try {
        await loginWithRedirect({
          authorizationParams: {
            prompt: "login",

            ...(connection
              ? {
                  connection,
                }
              : {}),
          },

          appState: {
            returnTo: "/post-login",
          },
        });
      } catch (loginError) {
        redirectStarted.current = false;

        console.error("Could not restart Auth0 login:", loginError);

        setError(
          "We could not restart the login process. Please return to the LEG-UP homepage and try again.",
        );
      }
    };

    restartLogin();
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading) {
    return <div style={{ padding: 32 }}>Preparing secure login...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to="/post-login" replace />;
  }

  if (error) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 32,
        }}
      >
        <div
          style={{
            maxWidth: 520,
            textAlign: "center",
          }}
        >
          <h1>Unable to restart login</h1>

          <p>{error}</p>

          <a href="/">Return to LEG-UP</a>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 32,
      }}
    >
      Redirecting to secure login...
    </div>
  );
}
